<div class="my-3 d-flex w-100 position-relative">
  <img class="w-100" style="border-radius: 4px" src="assets/images/report.webp">
  <button *ngIf="scopeService.checkScope('AND','admin:view:report:permissions')" routerLink="/dashboard/report/access-list" nbButton class="access-list-button"
          status="primary">مدیریت دسترسی‌ها
  </button>
  <button routerLink="/dashboard/report/queue-list" nbButton class="report-queue" [class.with-access-button]="scopeService.checkScope('AND','admin:view:report:permissions')"
          status="primary">فایل‌ها
  </button>
</div>
<nb-card>
  <nb-card-header>
    <div class="d-flex justify-content-between align-items-center">
      <span>لیست گزارشات موجود</span>
      <div class="d-flex gap-3">
        <div class="d-flex gap-2 align-items-center">
          <label>مرتب سازی بر اساس</label>
          <nb-select style="width: 300px;" [ngModel]="sortBy" (ngModelChange)="sortReports($event)">
            <nb-option value="desc">جدید به قدیمی</nb-option>
            <nb-option value="asc"> قدیمی به جدید</nb-option>
            <nb-option value="useCount">تعداد استفاده</nb-option>
          </nb-select>
        </div>
        <input type="search" style="min-width: 400px" nbInput status="primary" [(ngModel)]="searchQuery" placeholder="جستجو">
      </div>
    </div>
  </nb-card-header>
  <nb-card-body [nbSpinner]="loading">
    <div class="row">
      <ng-container *ngFor="let report of listOfReports | searchReport:searchQuery">
        <div class="col-12 col-md-4 col-lg-3">
          <nb-card status="basic" size="tiny">
            <nb-card-header>
              <div class="d-flex justify-content-between align-items-center">
                <span style="font-size: 12px">{{ report.name }}</span>
              </div>
            </nb-card-header>
            <nb-card-body><span style="font-size: 12px">{{ report.description }}</span></nb-card-body>
            <nb-card-footer>
              <div class="d-flex justify-content-between">
                <div class="d-flex gap-1 align-items-center">
                  <nb-tag-list>
                    <nb-tag [style.border-color]="output.color" [style.color]="output.color" class="cursor-pointer" (click)="searchQuery = output.name" size="tiny" status="primary" *ngFor="let output of report.tags" appearance="outline"
                            [text]="output.name"></nb-tag>
                  </nb-tag-list>
                </div>
                <button size="tiny" [routerLink]="'/dashboard/report/general/' + report.id" nbButton status="primary">گزارش‌گیری
                </button>
              </div>
            </nb-card-footer>
          </nb-card>
        </div>
      </ng-container>

    </div>
  </nb-card-body>
</nb-card>
